export const MED_CHRON_VIEW_TABS = {
  SUMMARY: "summary",
  VISITS: "visit",
  IMAGES: "images",
  FILES: "files",
  CHATS: "chats",
} as const;
